"use client";

import { useContentfulInspectorMode } from "@scott/contentful/live-preview-init";
import type { InspectorProps } from "../../lib/inspector";
import { Accordion, type AccordionProps } from "./accordion";

export type AccordionInspectorProps = InspectorProps<"container">;

export function AccordionPreview(props: Readonly<AccordionProps>) {
  const containerInspector = useContentfulInspectorMode({
    entryId: props.sys?.id,
  });

  return (
    <Accordion
      {...props}
      inspectorProps={{
        container: containerInspector({ fieldId: "internalName" }) ?? undefined,
      }}
    />
  );
}
